import React, { Component } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from 'react-router-dom';
import { collection, getDocs, query, orderBy, limit, db } from '../../api/firebaseConfig.js';

class ProjectSectionS4 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      posts: [], // Holds the posts data
    };
  }

  componentDidMount() {
    this.fetchPosts(); // Fetch posts when the component mounts
  }

  // Function to fetch posts from Firebase
  fetchPosts = async () => {
    try {
      const q = query(
        collection(db, "blogPosts"),
        orderBy("createdAt", "desc"),
        limit(3)
      );
      const querySnapshot = await getDocs(q);
      const postsList = querySnapshot.docs.map((doc) => {
        const post = doc.data();
        return {
          id: doc.id,
          imageprincipale: post.imageprincipale,
          title: post.title,
        };
      });
      this.setState({ posts: postsList }); // Set the state with the fetched posts
    } catch (error) {
      console.error("Error fetching posts: ", error);
    }
  };

  // Slider settings
  render() {
    const { posts } = this.state;
    const settings = {
      dots: false,
      arrows: true,
      speed: 1000,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    const ClickHandler = () => {
      window.scrollTo(10, 0);
    };

    return (
      <div className="wpo-project-area black-bg">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="wpo-project-wrap project-active owl-carousel">
              <Slider {...settings}>
                {posts.map((project, pot) => (
                  <div className="wpo-project-item" key={pot}>
                    <div className="wpo-project-img">
                      <img height={329} width={"100%"} src={project.imageprincipale} alt={project.title} />
                      <div className="left-border"></div>
                      <div className="right-border"></div>
                    </div>
                    <div className="wpo-project-text">
                      <h2>
                        <Link onClick={ClickHandler} to={`/riads-renove/${project.id}`}>
                          {project.title}
                        </Link>
                      </h2>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProjectSectionS4;
